import { ImageProperties } from '../imageProperties.model';
import { MetricColors } from './metricInterfaces.model';
import TemperatureIcon from '../../images/Icons/temperature.png';
import HumidityIcon from '../../images/Icons/humidity.png';
import AirIcon from '../../images/Icons/air.png';
import InactivityIcon from '../../images/Icons/inactivity.png';
import IlluminanceIcon from '../../images/Icons/illuminance.png';
import NoiseIcon from '../../images/Icons/noise.png';
import EnergyIcon from '../../images/Icons/energy.png';

export enum CardType {
    NONE = 'none',
    MULTIPLE = 'multiple',
    UP_LOW = 'UpLow'
}

export interface Card {
    id: string;
    title: string;
    metrics: CardMetric[],
    type: CardType,
}

export interface CardMetric {
    name: string,
    value: number
}

export interface CardConfigurations {
    key: string,
    icon: ImageProperties,
    circleColor: MetricColors,
    textColor: string
}

export interface DataCardHeaderProps {
    config: CardConfigurations,
    title: string
};

export interface DataCardCircleProps {
    config: CardConfigurations,
    metrics: CardMetric[],
    type: CardType
}

export interface DataCardLegendProps {
    metrics: CardMetric[],
    type: CardType,
    color: string
}

export const CardConfig: CardConfigurations[] = [
    {
        key: 'temperature',
        icon: {
            imagePath: TemperatureIcon,
            altText: 'Thermometer Icon'
        },
        circleColor: MetricColors.TEMPERATURE,
        textColor: `rgba(${MetricColors.TEMPERATURE}, 1)`
    },
    {
        key: 'humidity',
        icon: {
            imagePath: HumidityIcon,
            altText: 'Water Droplet Icon'
        },
        circleColor: MetricColors.HUMIDITY,
        textColor: `rgba(${MetricColors.HUMIDITY}, 1)`
    },
    {
        key: 'air',
        icon: {
            imagePath: AirIcon,
            altText: 'Air flow Icon'
        },
        circleColor: MetricColors.AIR_QUALITY,
        textColor: `rgba(${MetricColors.AIR_QUALITY}, 1)`
    },
    {
        key: 'inactivity',
        icon: {
            imagePath: InactivityIcon,
            altText: 'Pin with x inside icon'
        },
        circleColor: MetricColors.INACTIVITY,
        textColor: `rgba(${MetricColors.INACTIVITY}, 1)`
    },
    {
        key: 'illuminance',
        icon: {
            imagePath: IlluminanceIcon,
            altText: 'Lightbulb Icon'
        },
        circleColor: MetricColors.ILLUMINANCE,
        textColor: `rgba(${MetricColors.ILLUMINANCE}, 1)`
    },
    {
        key: 'noise',
        icon: {
            imagePath: NoiseIcon,
            altText: 'Loud speaker Icon'
        },
        circleColor: MetricColors.NOISE,
        textColor: `rgba(${MetricColors.NOISE}, 1)`
    },
    {
        key: 'energy',
        icon: {
            imagePath: EnergyIcon,
            altText: 'Lightning bolt energy Icon'
        },
        circleColor: MetricColors.ENERGY,
        textColor: `rgba(${MetricColors.ENERGY}, 1)`
    }
];